import React from 'react';
import {
    Responsive,
    Datagrid,
    SimpleList,
    TextField,
    SimpleForm,
    TextInput,
    required
} from 'admin-on-rest';
import List from '../admin/List';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import EditButton from '../buttons/EditButton';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/description';

export const fuseProductTypeIcon = Icon;

const styles = {
    productDiagram: {width: 'auto', margin: '0 0 0 1em'},
    fieldSmall: {flex: '0 1 10%', display: 'inline-block', maxWidth: '8.5em', overflow: 'hidden'},
};

/*
 * View: List
 */

// Set title for List Product Types
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Product Types</span>;

const ListDescription = () => {
    return (
        <span>
            <img src="img-diagram-Product-Type-List.png" alt="Diagram of Products - Product Types"
                 style={{...viewStyles.diagramRight, ...styles.productDiagram}}/>
            <p><strong>Product Types</strong> define the kind of products sold in your store(s). All Product
                Categories and Products derive from a Product Type Most businesses have only 1 Product Type.</p>
            <p>There are instances in the Seasonal Retail Industry, where you might require different Product Types
                depending on the Season. For example, a Store might sell Fireworks in the Summer, then Halloween
                Costumes in October. <strong>Create</strong> multiple Product Types to manage those Products.</p>
            <p>Sort Product Types by column. Click a Product Type's View icon to view its details, or Edit to modify
                the Product Type.</p>
            <hr style={viewStyles.break}/>
        </span>
    );
};

const ListDescriptionViewOnly = () => {
    return (
        <span>
            <img src="img-diagram-Product-Type-List.png" alt="Diagram of Products - Product Types"
                 style={{...viewStyles.diagramRight, ...styles.productDiagram}}/>
            <p><strong>Product Types</strong> define the kind of products sold in your store(s). All Product
                Categories and Products derive from a Product Type Most businesses have only 1 Product Type.</p>
            <p>There are instances in the Seasonal Retail Industry, where you might require different Product Types
                depending on the Season. For example, a Store might sell Fireworks in the Summer, then Halloween
                Costumes in October. <strong>Create</strong> multiple Product Types to manage those Products.</p>
            <p>Sort Product Types by column. Click a Product Type's View icon to view its details.</p>
            <hr style={viewStyles.break}/>
        </span>
    );
};

export const fuseProductTypeList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} perPage={10} sort={{field: 'name', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.description}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name" label="Name"/>
                    <TextField source="description" label="Description"/>
                    <EditButton/>
                </Datagrid>
            }
        />
    </List>
);

export const fuseProductTypeListViewOnly = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescriptionViewOnly/>} perPage={10} sort={{field: 'name', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.description}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name" label="Name"/>
                    <TextField source="description" label="Description"/>
                </Datagrid>
            }
        />
    </List>
);

/*
 * View: Create form
 */

// Set title for Create Product Type
const CreateTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                  className="avatar-title"/>Create a Product Type</span>;

const CreateDescription = () => {
    return (
        <span>
            <p><strong>Product Types</strong> configure the POS system to display products to be sold dependent on your
                Location(s) DBA. In most cases, a business will have only 1 Product Type.</p>
            <p>There are instances in the Seasonal Retail Industry, where you might require different Product Types
                depending on the Season. For example, a Store might sell Fireworks in the Summer, then Halloween
                Costumes in October. <strong>Create</strong> multiple Product Types to manage those Products.</p>
            <p>Enter the required fields below.</p>
        </span>
    );
};

/*
 * Create Product Type form
 */
export const fuseProductTypeCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm redirect="list">
            <TextInput source="name" label="Name of Product Type" validate={[required]}/>
            <span style={viewStyles.fieldDescription}>
                The <strong>Name</strong> of the overall Product Type.
            </span>

            <TextInput source="description" label="Product Type Description"/>
            <span style={viewStyles.fieldDescription}>
                Optional <strong>Description</strong> of the overall Product Type.
            </span>

            <span style={viewStyles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to Product Type List.
            </span>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
        </SimpleForm>
    </Create>
);

// Set title for Edit Product Type
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.name}` : 'Product Type'}</span>;
};

/*
 * Edit Product Type form
 */
export const fuseProductTypeEdit = (props) => (
    <Edit {...props} title={<EditTitle/>}>
        <SimpleForm>
            <TextInput source="name" label="Name of Product Type" validate={[required]}/>
            <span style={viewStyles.fieldDescription}>
                The <strong>Name</strong> of the overall Product Type.
            </span>

            <TextInput source="description" label="Product Type Description"/>
            <span style={viewStyles.fieldDescription}>
                Optional <strong>Description</strong> of the overall Product Type.
            </span>

            <span style={viewStyles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to Product Type List.
            </span>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Product/productType.js